import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { Drawer } from '@root/shared/ui-kit'

import { TransactionDetails } from '../transaction-details/transaction-details'

import type { Transaction } from '@root/entities/transaction'
import type { DrawerProps } from '@root/shared/ui-kit'

type Props = Pick<DrawerProps, 'onOpenChange' | 'open'> & {
  tx: Transaction.Transaction
}

export const TransactionDetailsDrawer: React.FC<Props> = ({
  open,
  onOpenChange,
  tx,
}) => {
  const { t } = useTranslation()

  return (
    <Root
      open={open}
      onOpenChange={onOpenChange}
      title={t('transaction.transaction_details')}
    >
      <TransactionDetails
        tx={tx}
        css={css`
          padding-block: 8px 34px;
        `}
      />
    </Root>
  )
}

const Root = styled(Drawer)``
